import { atom } from 'recoil'

import { CustomSeries, Minutes, Period, Tool } from '../enums'

export const chartState = atom<ChartState>({
  key: 'chartState',
  default: {
    period: 'days',
    minutes: 1,
    customSeries: 'average',
    tool: '기본',
  },
})

interface ChartState {
  period: Period
  minutes: Minutes
  customSeries?: CustomSeries
  tool: Tool
}
